const FlexibleTable = require('okCharts/FlexibleTable');

module.exports = FlexibleTable;
